import { API_BASE_URL } from "@/api/api.config";
import stringifyParams from "@/utils/stringifyParams";

const fetchLangstonSuggestionsService = async (text = "") => {
  const resource = `${API_BASE_URL}/api/v3/content/delivery/suggestions/`;

  const queryString = stringifyParams({
    needle: text,
    limit: 5,
  });

  try {
    const response = await fetch(`${resource}${queryString}`, {
      method: "GET",
      credentials: "include",
    });
    return await response?.json();
  } catch (error) {
    return error;
  }
};

export { fetchLangstonSuggestionsService };
